import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-refresh-redirect',
  templateUrl: './refresh-redirect.component.html',
  styleUrls: ['./refresh-redirect.component.css'],
  standalone: false
})
export class RefreshRedirectComponent implements OnInit {

  /**
   * This component is used for the sole purpose of being a pass-thru for refreshing the
   * page without changing the current location. This is essentially a dummy component which
   * has a route defined for it in app-routing. Please refer to the code in nav-menu.component.ts
   * for its usage. You will see that even though the code navigates to this component - the location
   * change is skipped - essentially keeping the user on the same page while also forcing the
   * Angular engine to refresh the page.
   * 
   * NOTE: This component is in the Shared folder but is not loaded in the shared module. The Shared
   * folder seemed the best location to keep this code as it is not a major component like dashboard
   * or dispatch.
   */
  constructor() { }

  ngOnInit() {
  }

}
